export const MODEL_ROUTE = '/kiosks';

export const OFFLINE_TIMEOUT = 1000 * 60 * 10;
